import { render, staticRenderFns } from "./mydetail.vue?vue&type=template&id=251f9595&scoped=true&"
import script from "./mydetail.vue?vue&type=script&lang=js&"
export * from "./mydetail.vue?vue&type=script&lang=js&"
import style0 from "./mydetail.vue?vue&type=style&index=0&id=251f9595&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251f9595",
  null
  
)

export default component.exports